import _get from 'lodash-es/get';
import { connect } from 'react-redux';
import {
  getUploadStatusInitiate,
  setUploadMsg,
  uploadEmployeesClear,
} from '../../actions/employee';
import { employeeUploadMsg } from '../common/components/constants';
import UploadStatus from './UploadStatus';

const mapStateToProps = state => {
  const uploadStatusData = _get(state, 'employees.uploadStatusData', {});

  return {
    uploadStatusData,
    uploadMsg: _get(state, 'employees.uploadMsg', employeeUploadMsg),
    isFetching:
      _get(state, 'apiState.GET_UPLOAD_STATUS.isFetching', true) &&
      !_get(state, 'apiState.GET_UPLOAD_STATUS.isIdle', false),
    fetched: _get(state, 'apiState.GET_UPLOAD_STATUS.success', true),
  };
};

const mapDispatchToProps = dispatch => ({
  clearUpload: () => dispatch(uploadEmployeesClear()),
  getUploadStatus: payload => dispatch(getUploadStatusInitiate(payload)),
  setFileUploadMsg: message => dispatch(setUploadMsg(message)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UploadStatus);
